const blockedTenantDialog = {
    title: 'Este entorno ha sido bloqueado',
    text: 'Este entorno ha sido descontinuado o bloqueado, todas las funciones estarán deshabilitadas, en caso de duda, llame al soporte',
  }
  
  export default blockedTenantDialog;
  